export default __webpack_public_path__ + "static/15-93dfc7e5d53cc4caca8ba0da0155bcbf.png";